import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  IconButton,
  Typography,
  Grid,
  Paper,
  Button
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LambdaFetch from '../functions/FetchFromLambda'
import LoadingButton from '../components/LoadingButton'
import { payrollDistributionCols } from '../constants/PayrollCols'
import LoadingCircle from '../components/common/LoadingCircle'
import { smallScreenWidth } from '../constants/AppConstants'
import AutocompleteDropDown from '../components/AutocompleteDropdown'
import ServerSideAutoCompletev2 from '../functions/ServerSideAutoCompletev2'
import { DashboardAthenaTable } from '../components/DashboardAthenaTable'
import DateInput from '../components/DateInput'
import OpenSearchDropdown from '../components/OpenSearchDropdown'
import AthenaLookupDropdown from '../components/AthenaLookupDropdown'
import { DashboardAthenaTableServerSideNoSelect } from '../components/DashboardAthenaTableServerSideNoSelect'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem'
  },
  treeRoot: {
    flexGrow: 1,
    margin: '1rem'
  }
}))

const defaultHeaders = {
  company: null,
  employee: '',
  fromDate: '',
  toDate: ''
}

export default function PayrollDistribution (props) {
  const useAthenaEmployeeLookup = props.employeeLookupProvider === 'athena'
  const [state, setstate] = useState({
    isLoading: false,
    data: null,
    tableKey: JSON.stringify(defaultHeaders)
  })
  const [showTable, setShowTable] = useState(false)
  const [headers, setHeaders] = useState(defaultHeaders)
  const [clearHeader, setClearHeaders] = React.useState(false)
  const [clearTrigger, setClearTrigger] = React.useState(false)

  const classes = useStyles()

  const { credentials } = props.fetchInitialData

  const handleChange = (name, value) => {
    setHeaders({ ...headers, [name]: !!value ? value.id : null })
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (JSON.stringify(headers) === state.tableKey) return null
    setShowTable(true)
    setstate({ ...state, isLoading: true, tableKey: JSON.stringify(headers) })
  }

  const handleCallback = (values, error) => {
    if (error) {
      setstate({ ...state, isLoading: false })
      setShowTable(false)
      return null
    }
    setstate({ ...state, isLoading: false })
  }



  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='delete'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        {useAthenaEmployeeLookup ? 'Payroll Distribution - Athena Lookup' : 'Payroll Distribution'}
      </Typography>
      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              <Grid item>
                <OpenSearchDropdown
                  id='company'
                  required
                  width='250px'
                  label='Company'
                  page="EMPLOYEE"
                  entity="COMPANY"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, company: val?.VALUE || null })
                  }}
                />
              </Grid>
              <Grid item>
                {useAthenaEmployeeLookup ? (
                  <AthenaLookupDropdown
                    id='employee'
                    lookup='employee'
                    required
                    disabled={!headers.company}
                    width='300px'
                    label='Employee'
                    accessToken={credentials.user.accessToken}
                    credentials={credentials}
                    clearTrigger={clearTrigger}
                    filters={{
                      COMPANY: headers.company
                    }}
                    onChange={(val) => {
                      setHeaders({ ...headers, employee: val?.VALUE || null })
                    }}
                  />
                ) : (
                  <OpenSearchDropdown
                    id='employee'
                    required
                    disabled={!headers.company}
                    width='300px'
                    label='Employee'
                    page="EMPLOYEE"
                    entity="EMPLOYEE"
                    searchFields={['DISPLAY']}
                    accessToken={credentials.user.accessToken}
                    credentials={credentials}
                    clearTrigger={clearTrigger}
                    filters={{
                      COMPANY: headers.company
                    }}
                    onChange={(val) => {
                      setHeaders({ ...headers, employee: val?.VALUE || null })
                    }}
                  />
                )}
              </Grid>
              {[
                {
                  id: 'fromDate',
                  label: 'From Date',
                  // isRequired: true
                },
                {
                  id: 'toDate',
                  label: 'To Date',
                  // isRequired: true,
                }
              ].map(field => {
                // Make field required if the other date field has a value
                const otherFieldId = field.id === 'fromDate' ? 'toDate' : 'fromDate'
                const isRequired = !!headers[otherFieldId]
                
                return (
                  <Grid key={field.id} item>
                    <DateInput
                      id={field.id}
                      key={clearHeader}
                      type={'date'}
                      required={isRequired}
                      label={field.label}
                      value={headers[field.id] || ''}
                      onChange={e => {
                        setHeaders({
                          ...headers,
                          [field.id]: !!e.target.value ? e.target.value : null
                        })
                      }}
                      variant='standard'
                      helperText={field.helperText}
                    />
                  </Grid>
                )
              })}
            </Grid>

            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label='Submit'
                disabled={
                  // Disable if one date is filled but the other is not
                  (headers.fromDate && !headers.toDate) || 
                  (!headers.fromDate && headers.toDate)
                }
                isLoading={state.isLoading}
                color='primaryVLButton'
                buttonType='submit'
              />
              {!!Object.values(headers).some(value => value !== '') && (
                <Button
                  onClick={() => {
                    setClearHeaders(!clearHeader)
                    setHeaders(defaultHeaders)
                    setClearTrigger(prev => !prev)
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  {' '}
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>

        {showTable && (
          <div style={{ marginTop: '1rem ' }}>
            <DashboardAthenaTable
              {...props}
              isTempTable={true}
              key={state.tableKey}
              params={{ ...headers }}
              tableColumns={payrollDistributionCols}
              reportParamName="pr_payroll_distribution_temp"
              reportName='pr_payroll_distribution_temp'
              tableTitle={''}
              callback={handleCallback}
              transform={r => r}
              downloadFileName={'Payroll_Distribution_Download'}
              separatedDateFilters={{
                GL_DATE: ['fromDate', 'toDate'],
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}
